import { render } from "./OverView.vue?vue&type=template&id=7da809f1&scoped=true"
import script from "./OverView.vue?vue&type=script&lang=ts"
export * from "./OverView.vue?vue&type=script&lang=ts"

import "./OverView.vue?vue&type=style&index=0&id=7da809f1&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-7da809f1"

export default script
import QSpace from 'quasar/src/components/space/QSpace.js';
import qInstall from "../../../node_modules/vue-cli-plugin-quasar/lib/runtime.auto-import.js";
qInstall(script, 'components', {QSpace});
